import { CustomerType } from '../../resources/base/models/enums';

export const tireServiceModalEvent = {
  core: {
    attributes: {
      viewChange: 'Tire service',
    },
  },
  eventInfo: [
    {
      eventType: 'interAction',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const saveQuotationEvent = {
  core: {
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'Calculator',
      eventAction: 'Accept',
      linkInformation: 'Calculator: Save',
    },
  ],
  event: 'interaction',
};

export const vehicleSummaryEvent = {
  core: {
    attributes: {
      viewChange: 'Vehicle summary',
    },
  },
  eventInfo: [
    {
      eventType: 'interAction',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const getPrintAndSendEmailButtonsEvent = (docNamesString: string) => ({
  core: {
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'interaction',
      eventAction: 'Success',
      linkInformation: `Docs requested via email: ${docNamesString}`,
    },
  ],
  event: 'interaction',
});

export const getPrintDocumentsEvent = (docNamesString: string) => ({
  core: {
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'interaction',
      eventAction: 'Success',
      linkInformation: `Docs printed: ${docNamesString}`,
    },
  ],
  event: 'interaction',
});

export const getSendEmailDocumentsEvent = (docNamesString: string) => ({
  core: {
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'interaction',
      eventAction: 'Success',
      linkInformation: `Docs requested via email: ${docNamesString}`,
    },
  ],
  event: 'interaction',
});

export const invalidTanEvent = {
  error: {
    errorMessage: 'Continue: Authentication: Invalid TAN',
  },
  eventInfo: [
    {
      eventType: 'interAction',
      eventAction: 'Success',
      linkInformation: 'Continue: Authentication: Invalid TAN',
    },
  ],
  event: 'interaction',
};

export const requestNewTanEvent = {
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
      linkInformation: 'Continue: Authentication: Request new TAN',
    },
  ],
  event: 'interaction',
};

export const continueAuthenticationEvent = {
  core: {
    pageInfo: {
      pageName: 'Continue: Authentication',
    },
    attributes: {
      viewChange: 'TAN input',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const creditCheckPageEvent = (result: 'pending' | 'rejection' | 'success') => ({
  core: {
    pageInfo: {
      pageName: `Credit check ${result}`,
    },
    attributes: {
      viewChange: `Credit check ${result}`,
    },
  },
  customerData: {
    ccResult: result,
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: result.toLocaleUpperCase(),
    },
  ],
  event: 'page',
});

export const outletPageEvent = {
  core: {
    pageInfo: {
      pageName: 'Outlet page',
    },
    attributes: {
      viewChange: 'Outlet page',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const configVehiclePageEvent = {
  core: {
    pageInfo: {
      pageName: 'Vehicle configuration',
    },
    attributes: {
      viewChange: 'Vehicle configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const configVehicleStandalonePageEvent = (form) => ({
  ...configVehiclePageEvent,
  product: [
    {
      vehicleModel: [
        {
          manufacturer: form?.data?.vehicleData?.brand,
          name: form?.data?.vehicleData?.brand,
          descriptionLong: `${form?.data?.vehicleData?.brand} ${form?.data?.vehicleData?.modelName}`,
          bodyType: form?.data?.vehicleData?.modelGroup,
          initialRegistrationDate: form?.data?.vehicleData?.regDate,
          currency: 'EUR',
          salesID: form?.data?.vehicleData?.orderNumber,
          basePrice_localCurrency: form?.data?.vehicleData?.catalogPrice,
          endPrice_localCurrency: form?.data?.vehicleData?.totalPrice,
          engine: {
            enginePower: form?.data?.vehicleData?.engine,
          },
        },
      ],
    },
  ],
});

export const customerContactDataEvent = (selectedCustomerType) => ({
  core: {
    pageInfo: {
      pageName: 'Customer contact data',
    },
    attributes: {
      viewChange: selectedCustomerType === CustomerType.INDIVIDUAL ? 'Private' : 'Business',
    },
  },
  form: {
    type: selectedCustomerType === CustomerType.INDIVIDUAL ? 'Personal data' : 'Company data',
    name: 'Contact data',
  },
  customerData: {
    loggedInUserGroup: selectedCustomerType,
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
});

export const productConfigurationEvent = (customerType) => ({
  core: {
    pageInfo: {
      pageName: 'Product configuration',
    },
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  customerData: {
    loggedInUserGroup: customerType,
    // TODO: restore when data is available in coherent and typed form in the state
    // yearOfBirth: formData?.data?.customerData?.dateOfBirth,
    // gender: formData?.data?.customerData?.gender,
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
    {
      eventType: 'Contact information',
      eventAction: 'Provided',
    },
  ],
  event: 'page',
});

export const productConfigurationPageEvent = {
  core: {
    attributes: {
      viewChange: 'Product configuration',
    },
  },
  eventInfo: [
    {
      eventType: 'Calculator',
      eventAction: 'Accept',
      linkInformation: 'Calculator: Calculate',
    },
  ],
  event: 'interaction',
};

export const applicationFormPageEvent = {
  core: {
    pageInfo: {
      pageName: 'Application form (co applicant)',
    },
    attributes: {
      viewChange: 'Personal data',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
    {
      eventType: 'Product configuration',
      eventAction: 'Completed',
    },
    {
      eventType: 'Product price',
      eventAction: 'Calculated',
    },
  ],
  event: 'page',
};

export const formErrorEvent = {
  event: 'interaction',
  eventInfo: [
    {
      eventType: 'Form',
      eventAction: 'Field error',
      eventTargetURL: null,
      linkInformation: 'Input error',
    },
  ],
};

export const errorTrackEvent = (error, analyticsData) => ({
  core: {
    pageInfo: {
      pageName: (error && analyticsData?.[`${error}`]?.pageName) || 'Error',
    },
    attributes: {
      viewChange: (error && analyticsData?.[`${error}`]?.viewChange) || 'Error',
    },
  },
  form: {
    type: null,
    name: null,
    errorFields: null,
  },
  error: {
    errorCode: error,
    errorMessage: (error && analyticsData?.[`${error}`]?.errorMessage) || 'Error',
  },
  eventInfo: [
    {
      eventType: (error && analyticsData?.[`${error}`]?.eventType) || 'Error',
      eventAction: (error && analyticsData?.[`${error}`]?.eventAction) || 'Technical error',
    },
  ],
  event: 'page',
});

export const interActionEvent = (errorMessage) => ({
  eventInfo: [
    {
      eventType: 'interAction',
      eventAction: 'Success',
      linkInformation: errorMessage,
    },
  ],
  event: 'interaction',
});

export const documentUploadEvent = {
  core: {
    pageInfo: {
      pageName: 'Document upload',
    },
    attributes: {
      viewChange: 'Document upload',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const contactDataEvent = (formData) => ({
  core: {
    pageInfo: {
      pageName: 'Customer contact data',
    },
    attributes: {
      viewChange: 'Save application form',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
  product: [
    {
      productAddons: [formData?.financialProduct?.insuranceAndServices],
      attributes: {
        duration: formData?.financialProduct?.calculation?.duration,
        durationUnit: 'Month',
        yearlyMileage: formData?.financialProduct?.yearlyMileage,
        contractMileage: formData?.financialProduct?.calculation?.contractMileage,
        netLoanAmount: formData?.financialProduct?.netLoanAndgrossLoan,
        grossLoanAmount: formData?.financialProduct?.netLoanAndgrossLoan,
        contractAmount: formData?.financialProduct?.totalAmount,
      },
    },
  ],
  dataPrivacyStatement: {
    allowPostalAds: formData?.transaction?.dataConsent?.receiveElectronicMail,
    allowPhoneAds: formData?.transaction?.dataConsent?.receiveOffers,
    allowElectronicAds: formData?.transaction?.dataConsent?.receiveElectronicMail,
    allowMailAds: formData?.transaction?.dataConsent?.receiveOffers,
    allowElectronicInvoices: formData?.transaction?.dataConsent?.receiveElectronicMail,
  },
});

export const applicationDataSavedEvent = {
  eventInfo: [
    {
      eventType: 'Application data',
      eventAction: 'Saved',
      linkInformation: 'Application form saved',
    },
  ],
  event: 'interaction',
};

export const applicationFormEvent = {
  core: {
    pageInfo: {
      pageName: 'Application form (main applicant)',
    },
    attributes: {
      viewChange: 'Personal data',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
    {
      eventType: 'Product configuration',
      eventAction: 'Completed',
    },
    {
      eventType: 'Product price',
      eventAction: 'Calculated',
    },
  ],
  event: 'page',
};

export const linkExpiredEvent = {
  core: {
    pageInfo: {
      pageName: 'Continue: Link expired',
    },
    attributes: {
      viewChange: 'Continue: Link expired',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const legitimationEvent = {
  eventInfo: [
    {
      eventType: 'Legitimation',
      eventAction: 'Start',
      linkInformation: 'Start signature',
    },
    {
      eventType: 'e-signature',
      eventAction: 'Start',
      linkInformation: 'Start signature',
    },
  ],
  event: 'interaction',
};

export const dealerLandingPageEvent = {
  core: {
    pageInfo: {
      pageName: 'Dealer landing page',
    },
    attributes: {
      viewChange: 'Dealer landing page',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
};

export const customerTypeEvent = (formData) => ({
  core: {
    pageInfo: {
      pageName: 'Customer type',
    },
    attributes: {
      viewChange: 'Customer type',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
    {
      eventType: 'Vehicle information',
      eventAction: 'Provided',
    },
  ],
  event: 'page',
  product: [
    {
      vehicleModel: [
        {
          manufacturer: formData?.vehicleData?.brand,
          name: formData?.vehicleData?.brand,
          descriptionLong: `${formData?.vehicleData?.brand} ${formData?.vehicleData?.modelName}`,
          bodyType: formData?.vehicleData?.modelGroup,
          initialRegistrationDate: formData?.vehicleData?.regDate,
          currency: 'EUR',
          salesID: formData?.vehicleData?.orderNumber,
          basePrice_localCurrency: formData?.vehicleData?.catalogPrice,
          endPrice_localCurrency: formData?.vehicleData?.totalPrice,
          engine: {
            enginePower: formData?.vehicleData?.engine,
          },
        },
      ],
    },
  ],
});

export const saveAndContinueEvent = (formData) => ({
  core: {
    pageInfo: {
      pageName: 'Customer contact data',
    },
    attributes: {
      viewChange: 'Save application form',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
  ],
  event: 'page',
  product: [
    {
      productAddons: [formData?.financialProduct?.insuranceAndServices],
      attributes: {
        duration: formData?.financialProduct?.calculation?.duration,
        durationUnit: 'Month',
        yearlyMileage: formData?.financialProduct?.yearlyMileage,
        contractMileage: formData?.financialProduct?.calculation?.contractMileage,
        netLoanAmount: formData?.financialProduct?.netLoanAndgrossLoan,
        grossLoanAmount: formData?.financialProduct?.netLoanAndgrossLoan,
        contractAmount: formData?.financialProduct?.totalAmount,
      },
    },
  ],
  dataPrivacyStatement: {
    allowPostalAds: formData?.transaction?.dataConsent?.receiveElectronicMail,
    allowPhoneAds: formData?.transaction?.dataConsent?.receiveOffers,
    allowElectronicAds: formData?.transaction?.dataConsent?.receiveElectronicMail,
    allowMailAds: formData?.transaction?.dataConsent?.receiveOffers,
    allowElectronicInvoices: formData?.transaction?.dataConsent?.receiveElectronicMail,
  },
});

export const getVehicleTypeSelectionEvent = (productType) => ({
  core: {
    pageInfo: {
      pageName: 'Vehicle type selection',
    },
    attributes: {
      viewChange: 'Vehicle type selection',
    },
  },
  eventInfo: [
    {
      eventType: 'pageView',
      eventAction: 'Success',
    },
    {
      eventType: 'Product journey',
      eventAction: 'Start',
    },
  ],
  event: 'page',
  product: [
    {
      category: productType,
      name: productType,
    },
  ],
});
